class BESSAppProjectDependency extends BESSAppBase {

    constructor() {
        super();
    }
}